export default "__VITE_ASSET__BC9rtf$K__"